import React from 'react';

export default class BaseDataProcessor {
  static SIGN_TYPE_ARROW = 'arrow';
  static SIGN_TYPE_SIGN = 'sign';

  get upwardsArrow() {
    return <span style={{ transform: 'rotate(-90deg)', display: 'inline-block' }}>➝</span>;
  }

  get downwardsArrow() {
    return <span style={{ transform: 'rotate(90deg)', display: 'inline-block' }}>➝</span>;
  }

  decorateDeltaValue(value, signType, emptyIfZero = false, processingFunction = Math.abs) {
    return signType === BaseDataProcessor.SIGN_TYPE_ARROW ?
      this.decorateWithArrow(value, emptyIfZero, processingFunction) :
      this.decorateWithSign(value, emptyIfZero, processingFunction);
  }

  decorateDeltaText(value, intervalText, emptyIfZero = false) {
    if(value > 0) {
      return `more than previous ${intervalText}`;
    } else if(value < 0) {
      return `less than previous ${intervalText}`;
    } else {
      return emptyIfZero ? <span>&zwnj;</span> : `same with previous ${intervalText}`;
    }
  }

  decorateWithArrow(value, emptyIfZero, processingFunction) {
    if(value > 0) {
      return <span style={{display: 'flex'}}>{this.upwardsArrow}{processingFunction(value)}</span>;
    } else if(value < 0) {
      return <span style={{display: 'flex'}}>{this.downwardsArrow}{processingFunction(value)}</span>;
    } else {
      return emptyIfZero ? <span>&zwnj;</span> : <span>=</span>;
    }
  }

  decorateWithSign(value, emptyIfZero, processingFunction) {
    if(value > 0) {
      return `+${processingFunction(value)}`;
    } else if(value < 0) {
      return `-${processingFunction(value)}`;
    } else {
      return emptyIfZero ? <span>&zwnj;</span> : <span>=</span>;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/dataProcessors/baseDataProcessor.js